import { FaDollarSign } from "react-icons/fa";

interface PagarProps {
  acao: () => void;
}
export function Pagar({ acao }: PagarProps) {
  return <FaDollarSign style={{ cursor: "pointer" }} onClick={acao} />;
}
